<template>
    <div>
        <app-header title="Profil" :profil="'true'"></app-header>
        <div class="page">

            <div class="profile_pic">
                <img src="../../assets/images/profil.png">
            </div>
            <table>
                <tr>
                    <td><img src="../../assets/images/upgrade.png"></td>
                    <td><span>Account Upgrade</span></td>
                    <td><img src="../../assets/images/next.png"></td>
                </tr>
                <tr>
                    <td><img src="../../assets/images/ausloggen.png"></td>
                    <td><span>Ausloggen</span></td>
                    <td><img src="../../assets/images/next.png"></td>
                </tr>
            </table>
            <div class="information">
                Profil informationen
            </div>
            <form>
                <div class="form-group">
                    <label for="vorname">Vorname</label>
                    <div class="input-group">
                        <input id="vorname" value="Max" class="form-control">
                        <div class="input-group-append"><img src="../../assets/images/modify.png"></div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="name">Name</label>
                    <div class="input-group">
                        <input id="name" value="Mustermann" class="form-control">
                        <div class="input-group-append"><img src="../../assets/images/modify.png"></div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="email">Email</label>
                    <div class="input-group">
                        <input id="email" value="mail@mustermann.com" class="form-control">
                        <div class="input-group-append"><img src="../../assets/images/modify.png"></div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="passwort">Passwort</label>
                    <div class="input-group">
                        <input id="passwort" value="********" type="password" class="form-control">
                        <div class="input-group-append"><img src="../../assets/images/modify.png"></div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
    import Header from '../Header';
    import Footer from '../Footer_menu'

    export default {
        computed: {
            items() {
                return this.$store.getters.Meine_trends;
            }
        },
        components: {
            appHeader: Header,
            appFooter: Footer
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../assets/css/variables';

    .page {
        padding-top: 60px;
        color: #252226;
        padding-bottom:55px;

        .profile_pic {
            text-align: center;
            background-color: #f7f7f7;;
        }

        table {
            width: 100%;

            tr {
                &:first-of-type {
                    border-bottom: 1px #e4e4e7 solid;
                }
            }

            td {
                &:nth-of-type(1) {
                    width: 45px;
                    height: 55px;
                    padding-left: 22px;

                }

                &:nth-of-type(2) {
                    span {
                        font-family: "SF UI Text Light";
                        padding-left: 10px;
                        color: #008880;
                        font-size: 1.5rem;
                        font-weight: 700;
                    }
                }
                &:nth-of-type(3) {
                    width: max-content;
                    padding-right: 3px;
                }
            }
        }
        .information {
            padding-top: 30px;
            padding-left: 22px;
            padding-bottom: 7px;
            font-size: 1.1rem;
            color: #9b9b9b;
            background: #f7f7f7;
        }

        form {
            margin: 17px 20px;
            div {
                margin-bottom: 10px;
                label {
                    color: #9b9b9b;
                    font-size: 1.1rem;
                    line-height: 16px;
                }
                input {
                    border: none;
                    font-size: 1.5rem;
                    padding: 0;
                }
            }
            button {
                display: block;
                margin: auto;
                background-color: #008880;
                width: 100%;
                padding: 15px;
                font-size: 1.5rem;
                font-weight: 700;
                color: white;
                border: none;
                border-radius: 5px;
            }
        }


    }


</style>



// WEBPACK FOOTER //
// src/components/profil/Profil.vue